import { Injectable } from '@angular/core';
import {Headers, Http} from '@angular/http';
import {ConnectionService} from './connection.service';
import {AppConfig} from '../app.config';
import {Observable} from 'rxjs/Observable';
import {Task} from '../entities/Task';
import {MaintenanceObject_DTO} from '../entities/MaintenanceObject_DTO';

@Injectable()
export class MaintenanceObjectService {

  apiUrl: string;

  //private headers = this.connectionService.GetAuthorizationHeader();
  headers(company : string = null) : Headers {
    return this.connectionService.GetAuthorizationHeader(company);
  }

  constructor(private http: Http, private connectionService: ConnectionService, private config : AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }

  Get(Root_No: string, searchInput: string, canHaveItems: boolean, filterByRootNo: boolean, Company_Reference : string = null): Observable<MaintenanceObject_DTO>
  {
    let url = this.apiUrl + 'api/MaintenanceObject/Get?searchInput=' + encodeURIComponent(searchInput || '') + '&canHaveItems=' + canHaveItems + "&filterByRootNo=" + filterByRootNo;
    return this.http
      .post(url, {Root_No : Root_No},{headers: this.headers(Company_Reference)})
      .map(response => response.json() as MaintenanceObject_DTO);
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/maintenance-object.service.ts